import React, { useState } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import style from './index.css';

const YiCheng = (props) => {
    const { content } = props;
    const [ tabIndex, setTabIndex ] = useState(0);

    const GetContent = () => {
        const images = content[tabIndex].imageList;

        return (
            <div>
                {
                    images.map((img, index) => {
                        return <img src={img} key={index} alt="" />;
                    })
                }
            </div>
        );
    };

    return (
        <div>
            <div className={style.tabWp}>
                {
                    content.map((c, index) => {
                        return <div key={index} className={`${style.tab} ${tabIndex === index ? style.active : ''}`} onClick={() => setTabIndex(index)}>{c.title}</div>;
                    })
                }
            </div>
            <div>
                {GetContent()}
            </div>
        </div>
    );
};

YiCheng.propTypes = {
    content: PropTypes.array
};

export default errorBoundary(YiCheng);
